import Menu from './Menu';
import icon from '../../assets/crm/icon.png';

export default function Header({ changePage, currentPage }) {
  return (
    <div style={styles.headerContainer}>
      <img src={icon} style={styles.imageStyle} />
      <Menu changePage={changePage} currentPage={currentPage} />
    </div>
  );
}

const styles = {
  headerContainer: {
    width: '100%',
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
    borderBottomWidth: 1,
    borderBottomColor: 'grey',
    borderBottomStyle: 'solid',
    position: 'relative',
  },
  imageStyle: {
    width: 90,
    height: 90,
    position: 'absolute',
    left: 0,
    top: -10,
  },
};
